import React from 'react';
import ExpandedComponent from "../../microComponents/tablePages/ExpandedComponent";

const ExpandedPrintQueue = ({item}) => {
    return (
        <ExpandedComponent items={[
            {title: 'توضیحات', value: item.description },
            {title: 'صادر کننده', value: item.createBy, class: '2md:hidden'},
            {title: 'تعداد', value: item.count, class: '2md:hidden'},
            {title: ' تاریخ ثبت', value: item.createTime, class: '2md:hidden'},
            {title: 'کد تایید', value: item.verificationCode, class: '2md:hidden'},

        ]}/>
    );
};

export default ExpandedPrintQueue;